module.exports = __webpack_public_path__ + "static/mccarthy-hall-2-12b0b1eaf2c5eb76b6ce352f8804f70a.jpg";